<script lang="ts" setup>
// Change layout template
import HomeContent from "~/components/home/HomeContent.vue";

definePageMeta({
    layout: "no-container",
});

// Data

// Simple (useSeoMeta) or useServerSeoMeta
useSeoMeta({
    title: "American Book Company - K-12 books and online testing",
});
</script>

<template>
    <div>
        <HomeContent />
    </div>
</template>

<style scoped></style>
